import { createAction } from '@ngrx/store';
import { UserEntity } from 'src/app/models';


export const users = createAction(
    'USERS',
    (payload: UserEntity[]) => ({payload})
);
